import { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useLogin, checkLoggedIn } from "./authConfig";
import { LoginContext } from "./loginContext";
import Layout from "./pages/layout/Layout";
import MobileLayout from "./pages/layout/MobileLayout";
import { getEhrUserId } from "./utils/urlParams";

const LayoutWrapper = ({ layout }: { layout?: "desktop" | "mobile" }) => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [userId, setUserId] = useState("");
    const [ehrUserId, setEhrUserId] = useState(getEhrUserId());
    if (useLogin) {
        const { instance } = useMsal();
        // Keep track of the mounted state to avoid setting state in an unmounted component
        const mounted = useRef<boolean>(true);

        useEffect(() => {
            mounted.current = true;
            checkLoggedIn(instance)
                .then(isLoggedIn => {
                    if (mounted.current) {
                        setLoggedIn(isLoggedIn);
                        // Set userId from active account if logged in
                        if (isLoggedIn) {
                            const account = instance.getActiveAccount();
                            if (account) {
                                setUserId(account.localAccountId || account.username || "");
                            }
                        }
                    }
                })
                .catch(e => {
                    console.error("checkLoggedIn failed", e);
                });
            return () => {
                mounted.current = false;
            };
        }, [instance, instance.getAllAccounts().length]);

        return (
            <LoginContext.Provider value={{ loggedIn, setLoggedIn, userId, setUserId, ehrUserId, setEhrUserId }}>
                {layout === "mobile" ? <MobileLayout /> : <Layout />}
            </LoginContext.Provider>
        );
    } else {
        return (
            <LoginContext.Provider
                value={{
                    loggedIn: true,
                    setLoggedIn,
                    userId,
                    setUserId,
                    ehrUserId,
                    setEhrUserId
                }}
            >
                {layout === "mobile" ? <MobileLayout /> : <Layout />}
            </LoginContext.Provider>
        );
    }
};

export default LayoutWrapper;
